import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../../utils/Axios";
import { GET_SAVE_FILTER_QUERY_KEY } from "../types/CommonTypes";

async function getSavedFilters(tenantId: any, hospitalId: any) {
  const { data } = await fetcher({
    url: `/hospital/custom-filters/all`,
    headers: {
      "x-tenant-id": tenantId,
      "x-hospital-id": hospitalId,
    },
  });
  return data;
}

export default function useGetSavedFiltersQuery(tenantId: any, hospitalId: any) {   
  return useQuery({
    queryKey: [GET_SAVE_FILTER_QUERY_KEY, tenantId, hospitalId],
    queryFn: () => getSavedFilters(tenantId, hospitalId),
    enabled: !!tenantId && !!hospitalId,
  });
}
